/** Recognize rich-text markup without interpreting legacy text such as <name> as HTML. */
export function isRichTextHtml(value: string): boolean {
  return /<\/?(?:p|br|strong|b|em|i|u|s|ul|ol|li|a|span|div|h[1-6]|blockquote|hr|table|thead|tbody|tr|td|th|img|script|style|iframe|svg|math)\b[^>]*>/i.test(value);
}